import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import SitemapPage from './SitemapPage';

/**
 * SitemapV2Page
 * Barista Map 風格 V2 殼：HeaderV2 + 完整 Hero + 奶油色文件區 + FooterV2
 * 對應路由：/zh/sitemap/v2、/en/sitemap/v2
 */
export default function SitemapV2Page() {
  const location = useLocation();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const isPreviewRoute = location.pathname.includes('/v2');
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/sitemap`;

  useEffect(() => {
    const fontId = 'v2-fonts-sitemap';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <>
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-[#f5f1ea]">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow={isEn ? 'Site Index' : '網站索引'}
          title={isEn ? 'Sitemap' : '網站地圖'}
          subtitle={
            isEn
              ? 'A complete index of pages and content across OnGU Studio E-commerce.'
              : 'OnGU Studio E-commerce 全站頁面與內容索引。'
          }
          backgroundImage="https://images.pexels.com/photos/1813466/pexels-photo-1813466.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: isEn ? 'Home' : '首頁', to: `/${lang}` },
            { label: isEn ? 'Sitemap' : '網站地圖' },
          ]}
          height="h-[420px] md:h-[500px]"
        />
        <main
          className="bg-[#f5f1ea]"
          style={{ fontFamily: "'EB Garamond', 'Noto Serif TC', serif" }}
        >
          <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16 md:py-24">
            <SitemapPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
